export default __webpack_public_path__ + "static/media/Triangle170.1335f694.svg";